var _defs, _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.66 82.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b58c3e;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ffc557;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #3e3f41;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2.61px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30.57,
    cy: 52.09,
    r: 30.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.57,
    cy: 52.09,
    r: 19.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30.57,
    cy: 52.09,
    r: 8.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.63 17.79 53.11 29.31 54.67 11.52 66.19 0 64.63 17.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "71.14 28 82.66 16.47 64.87 18.03 53.35 29.55 71.14 28"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30.57,
    y1: 52.09,
    x2: 65.02,
    y2: 17.65
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target_icon.708f31a73bb91c8bf1499811c62e58e4.svg";
export { ForwardRef as ReactComponent };